import { PaginatedResponse } from "../../types";
import {
  ChangeOfBrokerDetailed,
  COBBrokerOption,
  COBClientDetail,
  COBDashboardOverall,
} from "../../types/distributor";
import { api } from "../axios";

export function getChangeOfBrokerOptions(payload: {
  investmentAccountId: string;
}): Promise<COBBrokerOption[]> {
  return api.get(`change-of-broker/preference/`, {
    params: {
      investment_account_guid: payload.investmentAccountId,
    },
  });
}

export function createChangeOfBrokerRequest(payload: {
  investmentAccountId: string;
  preference: Record<string, number[]>;
}) {
  return api.post(`change-of-broker/`, {
    investment_account_guid: payload.investmentAccountId,
    preference: payload.preference,
  });
}

export function getChangeOfBrokerRequest(clientId: number) {
  return api.get(`change-of-broker/${clientId}/`);
}

export function getChangeOfBrokerDetailedRequest(
  clientId: number
): Promise<ChangeOfBrokerDetailed> {
  return api.get(`change-of-broker/${clientId}/detailed`);
}

export const getCOBStats = (): Promise<{ overall: COBDashboardOverall }> =>
  api.get("change-of-broker/stats/");

export const getCOBClientBreakdown = (payload: {
  page: number;
  pageSize: number;
  status?: string[];
}): Promise<PaginatedResponse<COBClientDetail>> =>
  api.get("change-of-broker/breakdown/", {
    params: {
      page: payload.page,
      page_size: payload.pageSize,
      status: payload.status,
    },
    paramsSerializer: { indexes: null },
  });

export const updateCobStatus = (payload: {
  investmentAccountId: string;
  status: string;
  folioIds: number[];
}) => {
  return api.post("change-of-broker/status/", {
    investment_account_id: payload.investmentAccountId,
    status: payload.status,
    folio_ids: payload.folioIds,
  });
};
